import request from '@/utils/request'

export function pcGetCategorys(data) {
  return request({
    url: 'businessCategory/pcGetCategorys',
    method: 'post',
    data,
  })
}

export function getCategorys(data) {
  return request({
    url: 'businessCategory/getCategorys',
    method: 'post',
    data,
  })
}

export function save(data) {
  return request({
    url: 'businessCategory/Save',
    method: 'post',
    data,
  })
}

export function del(data) {
  return request({
    url: 'businessCategory/Delete',
    method: 'post',
    data,
  })
}

export function getAll(data) {
  return request({
    url: 'businessCategory/getAll',
    method: 'post',
    data,
  })
}

